const nf = new Map<number, Intl.NumberFormat>();

/** 23.14 → "23,1" (separatori italiani, cifre fisse). */
export function fmt(v: number | null | undefined, digits = 1): string {
  if (v == null || Number.isNaN(v)) return '—';
  let f = nf.get(digits);
  if (!f) {
    f = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
    nf.set(digits, f);
  }
  return f.format(v);
}

const TZ = 'Europe/Rome';

/** Un fuso non valido arrivato dal server non deve spegnere lo schermo: si ripiega su Europe/Rome. */
function safeZone(timeZone: string): string {
  try {
    new Intl.DateTimeFormat('it-IT', { timeZone });
    return timeZone;
  } catch {
    return TZ;
  }
}

/** Parti di data/ora nel fuso del sito, indipendenti dal fuso del kiosk. */
export function siteTime(d: Date, zone = TZ) {
  const timeZone = safeZone(zone);
  const parts = new Intl.DateTimeFormat('it-IT', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '00';
  const hh = get('hour');
  const mm = get('minute');
  return {
    hhmm: `${hh}:${mm}`,
    ss: get('second'),
    hour: Number(hh) + Number(mm) / 60,
    dateLabel: new Intl.DateTimeFormat('it-IT', {
      timeZone,
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(d),
  };
}

export function hhmm(epochMs: number | null | undefined, zone = TZ): string {
  if (epochMs == null) return '—';
  const timeZone = safeZone(zone);
  return new Intl.DateTimeFormat('it-IT', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(epochMs);
}
